module.exports = __webpack_public_path__ + "img/img4.f7509996.jpg";